import {
  getTreeExpandedState,
  Group,
  RenderTreeNodePayload,
  Tree,
  TreeNodeData,
  useTree,
} from "@mantine/core";
import { HiFolder, HiFolderOpen } from "react-icons/hi";
import React, { useEffect, useRef } from "react";

import "./FolderTree.css";

interface FolderIconProps {
  hasChildren: boolean;
  expanded: boolean;
}

function FolderIcon({ hasChildren, expanded }: FolderIconProps) {
  if (!hasChildren) {
    return <HiFolder className="w-4 h-4 text-grey-400" />;
  }

  if (expanded) {
    return <HiFolderOpen className="w-4 h-4 text-blue-400" />;
  }

  return <HiFolder className="w-4 h-4 text-blue-400" />;
}

function renderTreeNode({
  node,
  expanded,
  hasChildren,
  elementProps,
}: RenderTreeNodePayload) {
  return (
    <Group gap={5} {...elementProps}>
      <FolderIcon hasChildren={hasChildren} expanded={expanded} />
      <span>{node.label}</span>
    </Group>
  );
}

export default function FolderTree(props: {
  data: TreeNodeData[];
  defaultSelectedFolderId?: string;
  defaultExpandedFolderIds?: string[];
  onFolderClick: (folderId: string) => void;
}) {
  const defaultSelectedFolderId = props.defaultSelectedFolderId ?? null;

  const tree = useTree({
    multiple: false,
  });

  // Handle node selection by watching the tree's selection state
  useEffect(() => {
    if (tree.selectedState.length > 0) {
      console.log(tree.selectedState);
      props.onFolderClick(tree.selectedState[0]);
    }
  }, [tree.selectedState]);

  useEffect(() => {
    if (!defaultSelectedFolderId) return;
    expandTreeToCurrentFolder();
  }, [props.data]);

  const expandTreeToCurrentFolder = () => {
    tree.select(defaultSelectedFolderId);
    tree.setExpandedState(
      getTreeExpandedState(props.data, props.defaultExpandedFolderIds)
    );
    return false;
  };

  return (
    <div className="w-full h-full">
      <div className="p-2">
        <Tree
          data={props.data}
          renderNode={renderTreeNode}
          levelOffset={8}
          selectOnClick
          clearSelectionOnOutsideClick={false}
          classNames={{
            root: "w-full",
            node: "py-1 px-2 rounded transition-colors",
          }}
          tree={tree}
        />
      </div>
    </div>
  );
}
